import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://infrasic.in";

const pageMetadata = {
    "/": {
        title: "Infrasic Intelligence | Forensic Investigations",
        description:
            "Infrasic Intelligence — Forensic Investigation, Financial Intelligence and Digital Forensics. We don't just identify fraud. We build defensible evidence.",
    },
    "/about": {
        title: "About Infrasic Intelligence | Forensic Investigation",
        description:
            "Learn about Infrasic Intelligence, a specialist practice combining forensic investigation, financial analysis, digital evidence and investigative intelligence.",
    },
    "/expertise": {
        title: "Forensic Investigation Services | Infrasic Intelligence",
        description:
            "Explore forensic investigations, financial intelligence, digital forensics, investigative due diligence and related services from Infrasic Intelligence.",
    },
    "/experience": {
        title: "Investigation Experience | Infrasic Intelligence",
        description:
            "Explore Infrasic Intelligence's experience supporting complex investigations while protecting client confidentiality and sensitive matter details.",
    },
    "/approach": {
        title: "Our Investigative Approach | Infrasic Intelligence",
        description:
            "See how Infrasic Intelligence scopes investigations, examines available records and digital evidence, and develops clear, evidence-based findings.",
    },
    "/contact": {
        title: "Contact Infrasic Intelligence | Mumbai, India",
        description:
            "Contact Infrasic Intelligence in Mumbai to discuss a forensic investigation, financial intelligence, digital evidence or a complex business matter.",
    },
} as const;

function setMeta(attribute: "name" | "property", key: string, content: string) {
    let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);

    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }

    element.content = content;
}

export default function Seo() {
    const { pathname } = useLocation();

    useEffect(() => {
        const metadata = pageMetadata[pathname as keyof typeof pageMetadata] ?? pageMetadata["/"];
        const canonicalPath = pathname in pageMetadata ? pathname : "/";
        const canonicalUrl = new URL(canonicalPath, SITE_URL).href;

        document.title = metadata.title;
        setMeta("name", "description", metadata.description);
        setMeta("property", "og:title", metadata.title);
        setMeta("property", "og:description", metadata.description);
        setMeta("property", "og:url", canonicalUrl);
        setMeta("name", "twitter:title", metadata.title);
        setMeta("name", "twitter:description", metadata.description);

        let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }
        canonical.href = canonicalUrl;
    }, [pathname]);

    return null;
}